
export default {
  data() {
    return {
      activeSlide: 0,
      inView: false,
      isEnd: false,
      isBeginning: true,
      swiperOptions: {
        autoplay: true,
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 1500,
        loop: false,
        on: {
          slideChange: () => {
            this.activeSlide = this.$refs.mySwiper.mySwiper.activeIndex;
            // this.$emit("activeSlide", this.mySwiper.activeIndex);
          },
        },
        pagination: {
          el: ".swiper-solutions-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-solution-next",
          prevEl: ".swiper-solution-prev",
        },
      },

      options: [
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "title",
          label: "Title",
          type: "text",
        },
        {
          name: "subtitle",
          label: "Subtitle",
          type: "text",
        },
        {
          name: "description",
          label: "Description",
          type: "tipTap",
        },
        {
          name: "link",
          label: "Link",
          type: "link",
        },
      ],
    };
  },
  // computed: {
  //   swiper() {
  //     return this.$refs.mySwiper.swiper;
  //   },
  // },
  mounted() {
    setTimeout(() => {
      if (this.mySwiper && !this.$isInEditMode) {
        this.activeSlide = this.mySwiper.activeIndex;
        this.swiper.on("slideChange", () => {
          this.onSwipe(this);
        });
      }
    }, 500);
  },
  methods: {
    setActiveSlide(val) {
      this.activeSlide = val;
    },
    prev() {
      this.mySwiper.slidePrev();
      if (this.mySwiper.isEnd) {
        this.isEnd = true;
      } else {
        this.isEnd = false;
      }
      if (this.mySwiper.isBeginning) {
        this.isBeginning = true;
      } else {
        this.isBeginning = false;
      }
    },
    next() {
      this.mySwiper.slideNext();
      if (this.mySwiper.isEnd) {
        this.isEnd = true;
      } else {
        this.isEnd = false;
      }
      if (this.mySwiper.isBeginning) {
        this.isBeginning = true;
      } else {
        this.isBeginning = false;
      }
    },

    goToSlide(slide) {
      // this.activeSlide = slide;
      this.$refs.mySwiper.mySwiper.slideTo(slide, 1500, 0);
    },
  },
};
